/* Niconi cart drawer – offer bar animation + patakha celebration.
   Works with the theme's own drawer refresh: it watches the drawer markup,
   reads data-count from .nc-offer and fires when a new offer is unlocked. */
(function () {
  if (window.__ncCartOffer) return;
  window.__ncCartOffer = true;

  var KEY = 'ncOfferLastCount';
  var last = null;
  var lastPct = null;
  var pending = null;
  var queued = false;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  try {
    var saved = sessionStorage.getItem(KEY);
    if (saved !== null && saved !== '') last = parseFloat(saved);
  } catch (e) {}

  function save(v) {
    last = v;
    try { sessionStorage.setItem(KEY, String(v)); } catch (e) {}
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function drawerOpen() {
    var d = drawerEl();
    if (!d) return false;
    if (d.classList.contains('active')) return true;
    var inner = d.querySelector('.drawer__inner');
    if (!inner) return false;
    var r = inner.getBoundingClientRect();
    return r.width > 0 && r.left < window.innerWidth - 10;
  }

  function animateFill(el) {
    if (el.getAttribute('data-nc-seen') === '1') return;
    el.setAttribute('data-nc-seen', '1');
    var pct = parseFloat(el.getAttribute('data-pct')) || 0;
    var fill = el.querySelector('.nc-offer__fill');
    if (fill && lastPct !== null && lastPct !== pct && !reduceMotion) {
      fill.style.transition = 'none';
      fill.style.width = lastPct + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    }
    lastPct = pct;
  }

  function check() {
    queued = false;
    var el = document.querySelector('cart-drawer .nc-offer') || document.querySelector('.nc-offer');
    if (el) {
      animateFill(el);
      var count = parseFloat(el.getAttribute('data-count')) || 0;
      if (last === null) {
        save(count);
      } else if (count !== last) {
        var goals = (el.getAttribute('data-goals') || '').split(',').filter(Boolean).map(Number);
        var labels = (el.getAttribute('data-labels') || '').split('||');
        var hit = -1;
        for (var i = 0; i < goals.length; i++) {
          if (last < goals[i] && count >= goals[i]) hit = i;
        }
        save(count);
        if (hit > -1 && el.getAttribute('data-celebrate') === 'true') {
          pending = {
            label: labels[hit] || '',
            text: el.getAttribute('data-celebrate-text') || '[reward] unlocked!',
            sub: el.getAttribute('data-celebrate-sub') || '',
            at: Date.now()
          };
        } else if (count < last) {
          pending = null;
        }
      }
    }
    if (pending && Date.now() - pending.at > 15000) pending = null;
    if (pending && drawerOpen()) {
      var p = pending;
      pending = null;
      setTimeout(function () { fire(p); }, 300);
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  function fire(p) {
    var d = drawerEl();
    var inner = d && d.querySelector('.drawer__inner');
    if (!inner) return;
    var r = inner.getBoundingClientRect();
    if (r.width === 0) return;

    var layer = document.createElement('div');
    layer.className = 'nc-fx';
    layer.style.left = r.left + 'px';
    layer.style.top = r.top + 'px';
    layer.style.width = r.width + 'px';
    layer.style.height = r.height + 'px';

    if (!reduceMotion) {
      var sparksWrap = document.createElement('div');
      sparksWrap.setAttribute('aria-hidden', 'true');
      var colors = ['#ffd23f', '#ff9f1c', '#ff4d2e', '#fff1a8', '#f97132', '#ff6fa8'];
      var centers = [[26, 30, 0], [74, 24, 220], [52, 50, 440]];
      centers.forEach(function (c, ci) {
        var flash = document.createElement('span');
        flash.className = 'nc-fx__flash';
        flash.style.setProperty('--x', c[0] + '%');
        flash.style.setProperty('--y', c[1] + '%');
        flash.style.setProperty('--delay', c[2] + 'ms');
        sparksWrap.appendChild(flash);
        var n = 22;
        for (var i = 0; i < n; i++) {
          var s = document.createElement('span');
          s.className = 'nc-fx__spark';
          s.style.setProperty('--x', c[0] + '%');
          s.style.setProperty('--y', c[1] + '%');
          s.style.setProperty('--a', Math.round((360 / n) * i + Math.random() * 8) + 'deg');
          s.style.setProperty('--d', (55 + Math.round(Math.random() * 55)) + 'px');
          s.style.setProperty('--l', (9 + Math.round(Math.random() * 10)) + 'px');
          s.style.setProperty('--c', colors[(i + ci) % colors.length]);
          s.style.setProperty('--delay', (c[2] + Math.round(Math.random() * 50)) + 'ms');
          s.style.setProperty('--fall', (18 + Math.round(Math.random() * 30)) + 'px');
          sparksWrap.appendChild(s);
        }
      });
      layer.appendChild(sparksWrap);
    }

    var toast = document.createElement('div');
    toast.className = 'nc-fx__toast';
    toast.setAttribute('role', 'status');
    var footer = inner.querySelector('.drawer__footer');
    if (footer) {
      var fr = footer.getBoundingClientRect();
      toast.style.setProperty('--b', Math.max(16, r.bottom - fr.top + 12) + 'px');
    }
    toast.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffd23f" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"></path></svg>';
    var span = document.createElement('span');
    var strong = document.createElement('strong');
    strong.textContent = p.text.replace('[reward]', p.label);
    span.appendChild(strong);
    if (p.sub) span.appendChild(document.createTextNode(' ' + p.sub));
    toast.appendChild(span);
    layer.appendChild(toast);

    document.body.appendChild(layer);
    setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 2100);
  }

  function start() {
    schedule();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /* ---------- Upsell "+ Add" button: add straight to cart and refresh the drawer ---------- */
  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshDrawer(sections) {
    var d = drawerEl();
    if (sections && sections['cart-drawer'] && d) {
      var inner = sectionHTML(sections['cart-drawer'], '#CartDrawer');
      var target = d.querySelector('#CartDrawer');
      if (inner !== null && target) {
        target.innerHTML = inner;
        d.classList.remove('is-empty');
        var overlay = d.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof d.close === 'function') overlay.addEventListener('click', d.close.bind(d));
      }
    }
    if (sections && sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = sectionHTML(sections['cart-icon-bubble'], '.shopify-section') || sectionHTML(sections['cart-icon-bubble'], 'body');
      if (bubble && html !== null) bubble.innerHTML = html;
    }
    document.dispatchEvent(new CustomEvent('nc:cart-updated'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-nc-add')), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
        if (res.j.sections) {
          refreshDrawer(res.j.sections);
        } else {
          return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(refreshDrawer);
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.setAttribute('title', err.message);
        setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
      });
  });

  /* Upsell slider arrows */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[data-nc-scroll]');
    if (!arrow) return;
    var list = arrow.parentNode.querySelector('.nc-upsells__list');
    var card = list && list.querySelector('.nc-upsell');
    if (!list || !card) return;
    list.scrollBy({ left: Number(arrow.getAttribute('data-nc-scroll')) * (card.offsetWidth + 10), behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
